import React from 'react';
import moment from 'moment';

import sortIcon from 'assets/images/sort-arrow.png';
import parsfixed from 'utils/values/parsfixed.util';

class TableLastStockMovement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this.getWindowScrollTop();
    // document.addEventListener('mousedown', this.handleClickOutside);
  }
  getWindowScrollTop = () => {
    if (window.pageYOffset) {
      return window.pageYOffset;
    } else if (document.documentElement) {
      return document.documentElement.scrollTop;
    }
    return 0;
  };

  searchFunc = (el) =>
    el
      .getName()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString('en-GB')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[\u00E9]/g, '')
      .search(this.props.search) !== -1 ||
    el
      .getBrand()
      .trim()
      .normalize('NFD')
      .replace(/^0+'/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString('en-GB')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getFamily()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString('en-GB')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getCategory()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString('en-GB')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    (el.barcode ? el.barcode.toString() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1;

  render() {
    const categoryKeys = this.props.data.filter(this.searchFunc);
    return (
      <div data-bem="TableLastStockMovement">
        <div data-bem="TableLastStockMovement__table-header-container" className="sort-nav tbl-last-stock-movement">
          <table data-bem="TableLastStockMovement__table-header" className="tbl-fixed-header">
            <tbody>
              <tr>
                <td className="brand-name">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('brand');
                    }}
                  >
                    <span>Brand</span>
                    <img src={sortIcon} alt="Sort by Brand" />
                  </span>
                </td>
                <td className="product-name">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('title');
                    }}
                  >
                    <span>Product name</span>
                    <img src={sortIcon} alt="Sort by product" />
                  </span>
                </td>
                {/* Coming soon */}
                {/* <td className="category">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                          this.props.onAddSort('category');
                        }}
                  >
                    <span>Category</span>
                    <img src={sortIcon} alt="Sort by Category" />
                  </span>
                </td> */}
                <td style={{ width: '100px' }}>
                  <span
                    role="button"
                    tabIndex={0}
                    className="two-lines sm"
                    onClick={() => {
                      this.props.onAddSort('quantity');
                    }}
                  >
                    <span>Quantity in stock </span>
                    <img src={sortIcon} alt="Sort by Category" />
                  </span>
                </td>
                <td style={{ width: '100px' }}>
                  <span
                    role="button"
                    tabIndex={0}
                    className="two-lines sm"
                    onClick={() => {
                      this.props.onAddSort('dateOfLastChange');
                    }}
                  >
                    <span>Date of last change</span>
                    <img src={sortIcon} alt="Sort by used" />
                  </span>
                </td>
                <td style={{ width: '100px' }}>
                  <span
                    role="button"
                    tabIndex={0}
                    className="two-lines sm"
                    onClick={() => {
                      this.props.onAddSort('amountLastChange');
                    }}
                  >
                    <span>Amount of last change</span>
                    <img src={sortIcon} alt="Sort by sold" />
                  </span>
                </td>
                <td style={{ width: '100px' }}>
                  <span
                    role="button"
                    tabIndex={0}
                    className="two-lines sm"
                    onClick={() => {
                      this.props.onAddSort('typeOfLastChange');
                    }}
                  >
                    <span>Type of last change</span>
                    <img src={sortIcon} alt="Sort by cost used" />
                  </span>
                </td>
                <td style={{ width: 'auto' }} />
              </tr>
            </tbody>
          </table>
        </div>
        <div data-bem="TableLastStockMovement__table-body-container" className="tbl-container">
          <table data-bem="TableLastStockMovement__table-body" id="btlSt" className="table-stocks">
            <tbody>
              {categoryKeys.map((key) => {
                const stocks = key;
                return (
                  <tr key={stocks.id}>
                    <td
                      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                      role="button"
                      tabIndex={0}
                      className="brand-name"
                      onClick={() => {
                        this.props.OnClickRow(stocks);
                      }}
                    >
                      <span>{stocks.brand ? stocks.brand : 'Unknown'}</span>
                    </td>
                    <td
                      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                      role="button"
                      tabIndex={0}
                      className="product-name"
                      onClick={() => {
                        this.props.OnClickRow(stocks);
                      }}
                    >
                      {stocks.title}
                    </td>
                    {/* Coming soon */}
                    {/* <td className="category">
                                  Category
                          </td> */}
                    <td style={{ width: '98px', textAlign: 'center' }}>{parsfixed(stocks.units_in_stock)}</td>
                    <td style={{ width: '98px', textAlign: 'center' }}>
                      {stocks.latest_change ? moment(stocks.latest_change.timestamp).format('DD-MM-YYYY') : ''}
                    </td>
                    <td style={{ width: '98px', textAlign: 'center' }}>
                      {stocks.latest_change ? parsfixed(stocks.latest_change.amount) : 0}
                    </td>
                    <td style={{ width: '98px', textAlign: 'center' }}>
                      {stocks.latest_change && stocks.latest_change.type
                        ? stocks.latest_change.type.charAt(0).toUpperCase() +
                          stocks.latest_change.type.slice(1).replace('_', ' ')
                        : 'New in'}
                    </td>
                    <td style={{ width: 'auto' }} />
                  </tr>
                );
              })}
              {categoryKeys.length === 0 && (
                <tr>
                  <td style={{ textAlign: 'center' }}>No products to show.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default TableLastStockMovement;
